import { trace, getRandomInt } from 'rytm-helpers';

import {
  BG_PAN_MIN,
  BG_PAN_MAX,
  BG_VOL_MIN,
  BG_VOL_MAX,
  BG_LAYER_3_PROB,
  BG_LAYER_3_VOL_MIN,
  BG_LAYER_3_VOL_MAX,
  ACCENT_POT_SIZE_MIN,
  ACCENT_POT_SIZE_MAX,
  ACCENT_PAUSE_MIN,
  ACCENT_PAUSE_MAX,
  ACCENT_LAYERS_MIN,
  ACCENT_LAYERS_MAX,
  ACCENT_VOL_MIN,
  ACCENT_VOL_MAX,
  ACCENT_PAN_MIN,
  ACCENT_PAN_MAX,
} from './config';

let currentPot = [];

export const getPauseTime = () => {
  return getRandomInt(ACCENT_PAUSE_MIN, ACCENT_PAUSE_MAX);
}
export const getAccentLayers = () => {
  return getRandomInt(ACCENT_LAYERS_MIN, ACCENT_LAYERS_MAX);
}
// SET new random accent sounds pot (bank) - when composition changes
export const setAccentSoundPot = (sounds) => {
  currentPot = [];
  const potSize = getRandomInt(ACCENT_POT_SIZE_MIN, ACCENT_POT_SIZE_MAX);
  if (potSize > sounds.length) {
    console.warn("Pot size is bigger than number of samples");
    return;
  }
  let indexes = [];
  for (let i = 0; i < potSize; i++) {
    // randomize index (ind) until it is not in indexes array
    let ind = getRandomInt(0, sounds.length - 1);
    while (indexes.includes(ind)) {
      ind = getRandomInt(0, sounds.length - 1);
    }
    currentPot.push({
      src: [sounds[ind]],
    });
    indexes.push(ind);
  }
  return currentPot;
}
export const getRandomAccentParams = () => {
  if (currentPot.length == 0) {
    console.warn("Accent sounds pot is empty");
    return;
  }
  const ind = getRandomInt(0, currentPot.length - 1);
  const soundId = ind + "_" + Date.now() + "_" + Math.floor(Math.random() * 999999);
  return {
    soundId,
    ...currentPot[ind],
    volume: getRandomPerc(ACCENT_VOL_MIN, ACCENT_VOL_MAX),
    stereo: getRandomPerc(ACCENT_PAN_MIN, ACCENT_PAN_MAX),
  };
}


// ## BG Generate a pair of random bg sounds
export const getBackgroundSoundParams = (sounds) => {
  // random indexes
  const ind1 = getRandomInt(0, sounds.length - 1);
  let ind2 = getRandomInt(0, sounds.length - 1);
  ind2 = ind2 == ind1 ? getRandomInt(0, sounds.length - 1) : ind2;
  let sndParams = [
    {
      src: [sounds[ind1]], 
      volume: getRandomPerc(BG_VOL_MIN, BG_VOL_MAX),
      loop: true,
      stereo: - getRandomPerc(BG_PAN_MIN, BG_PAN_MAX),
    },
    {
      src: [sounds[ind2]],
      volume: getRandomPerc(BG_VOL_MIN, BG_VOL_MAX),
      loop: true,
      stereo: getRandomPerc(BG_PAN_MIN, BG_PAN_MAX),
    }
  ];
  if (getProbability(BG_LAYER_3_PROB)) {
    let ind3 = getRandomInt(0, sounds.length - 1);
    ind3 = (ind3 == ind1 || ind3 == ind2) ? getRandomInt(0, sounds.length - 1) : ind3;
    sndParams.push({
      src: [sounds[ind3]],
      volume: getRandomPerc(BG_LAYER_3_VOL_MIN, BG_LAYER_3_VOL_MAX),
      loop: true,
      stereo: 0,
    })
  }
  return sndParams;
}
// ### Helpers ###
const getRandomPerc = (min, max) => {
  return getRandomInt(min * 100, max * 100) / 100;
}
const getProbability = (prob) => {
  return Math.random() < prob;
}
